export default "__VITE_PUBLIC_ASSET__3fd884cf__"